import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloading = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.32 4.25999C16.8034 3.01485 14.9525 2.24595 13 2.04999V4.06999C14.46 4.24999 15.79 4.82999 16.9 5.68999L18.32 4.25999ZM19.93 11H21.95C21.75 8.98999 20.95 7.15999 19.74 5.67999L18.31 7.09999C19.1922 8.22991 19.752 9.57758 19.93 11ZM18.31 16.9L19.74 18.33C20.9826 16.8118 21.7511 14.9617 21.95 13.01H19.93C19.7497 14.4288 19.1901 15.7726 18.31 16.9ZM13 19.93V21.95C15.01 21.75 16.84 20.95 18.32 19.74L16.89 18.31C15.79 19.17 14.46 19.75 13 19.93ZM13 12V6.99999H11V12H7L12 17L17 12H13ZM11 19.93V21.95C5.95 21.45 2 17.19 2 12C2 6.80999 5.95 2.54999 11 2.04999V4.06999C7.05 4.55999 4 7.91999 4 12C4 16.08 7.05 19.44 11 19.93Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDownloading);
export default ForwardRef;
